import { render, staticRenderFns } from "./TheTicketsFAQ.vue?vue&type=template&id=1d22169a&"
import script from "./TheTicketsFAQ.vue?vue&type=script&lang=js&"
export * from "./TheTicketsFAQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports